<template>
    <div class="profile">
        <div class="tabs-content">
            <div class="container">
                <h3 class="heading">
                    <br/>
                    <i class="nav-icon career-pink-icon"></i>
                    <br/><span>Career</span>
                </h3>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="container">
                        <div class="tabContent" id="tabs-1" :class="{ current: true }">
                            <div class="container">
                                <div class="row yourFaves" v-if="getAuthCareerVideos">
                                    <div class="col-md-12">
                                        <div class="mostRecent">
                                            <button type="button">
                                                most recent
                                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                                            </button>
                                            <span>Sort by</span>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" v-for = "video in getAuthCareerVideos">
                                        <img class="jw-img" :src="video.image" @click="setVideoPlayerObject(video.mediaid)" />
                                        <p>{{video.title}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {input, checkbox, buttonGroup, spinner} from 'vue-strap'
    export default {
        spinner: false,
        components: {
            'bs-input': input,
            'checkbox': checkbox,
            'button-group': buttonGroup,
            'spinner': spinner,
            alert
        },
        name: 'profile',
        data: function () {
            return {
                interestIndexes: [],
                userInterests: [],
                spinner: false,
                tabs: {
                    videos: true,
                    chat: false,
                    discussion: false
                }
            }
        },
        methods: {
            switchTab: function (id) {
                for (let tab in this.tabs) {
                    this.tabs[tab] = id === tab
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            getInterestStatus (interest) {
                if (this.getUserInterests) {
                    let selectedInterestId
                    console.log(selectedInterestId)
                    let exists = this.getUserInterests.filter(selectedInterestId => {
                        return selectedInterestId.interestId === interest.interestId
                    })
                    if (exists && exists.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setVideoPlayerObject (videoCode) {
                this.$router.push(`/watch/${videoCode}`)
            }
        },
        computed: {
            ...mapGetters([
                'getAuthCareerVideos', 'user', 'error'
            ])
        },
        mounted () {
            this.$store.dispatch('GETAUTHVIDEOS', 'CAREER').then(() => {
            })
        }
    }
</script>



// WEBPACK FOOTER //
// NewCareer.vue?4b51cbaa